import React, { useState, useMemo } from 'react';
import { Link } from 'react-router-dom';
import hamburgerIcon from '../assets/images/ham.svg'; // Import hamburger icon
import closeIcon from '../assets/images/close.svg'; // Import close icon

const Skills = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  const closeSidebar = () => {
    setIsSidebarOpen(false);
  };

  // Memoized skills data for optimization
  const skills = useMemo(() => [
    {
      icon: 'fab fa-html5',
      title: 'HTML & CSS',
      description: 'Proficient in modern web design, creating responsive and accessible websites.',
    },
    {
      icon: 'fab fa-js',
      title: 'JavaScript',
      description: 'Strong understanding of JavaScript frameworks, building dynamic web applications.',
    },
    {
      icon: 'fab fa-python',
      title: 'Python & Django',
      description: 'Experienced with backend development, API creation, and Django framework.',
    },
    {
      icon: 'fas fa-database',
      title: 'Database Management',
      description: 'Well-versed in SQL, MariaDB, and database optimization techniques.',
    },
  ], []);

  return (
    <div>
      {/* Sidebar */}
      <div className={`sidebar ${isSidebarOpen ? 'open' : ''}`}>
        <div className="sidebar-header">
          {isSidebarOpen && (
            <img
              src={closeIcon}
              alt="Close Sidebar"
              className="close-btn"
              onClick={closeSidebar}
              aria-label="Close navigation menu"
            />
          )}
        </div>
        <ul className="sidebar-links">
          <li><Link to="/" onClick={closeSidebar}>Home</Link></li>
          <li><Link to="/about" onClick={closeSidebar}>About</Link></li>
          <li><Link to="/skills" onClick={closeSidebar}>Skills</Link></li>
          <li><Link to="/projects" onClick={closeSidebar}>Projects</Link></li>
          <li><Link to="/contact" onClick={closeSidebar}>Contact</Link></li>
        </ul>
      </div>

      {/* Hamburger Menu */}
      {!isSidebarOpen && (
        <img
          src={hamburgerIcon}
          alt="Open Sidebar"
          className="hamburger"
          onClick={toggleSidebar}
          aria-label="Open navigation menu"
        />
      )}

      {/* Header Section */}
      <header>
        <nav className="navbar navbar-expand-lg">
          <div className="left">
            <Link to="/" className="portfolio-link">
              <span className="purple">P</span>rem Portfolio
            </Link>
          </div>
          <div className="right ml-auto">
            <ul className="navbar-nav">
              <li className="nav-item"><Link className="nav-link" to="/about" onClick={closeSidebar}>About</Link></li>
              <li className="nav-item"><Link className="nav-link" to="/skills" onClick={closeSidebar}>Skills</Link></li>
              <li className="nav-item"><Link className="nav-link" to="/projects" onClick={closeSidebar}>Projects</Link></li>
              <li className="nav-item"><Link className="nav-link" to="/contact" onClick={closeSidebar}>Contact me</Link></li>
            </ul>
          </div>
        </nav>
      </header>

      {/* Main Section */}
      <main>
        {/* Skills Section */}
        <section className="skills">
          <h2>Skills</h2>
          <div className="skills-container">
            {skills.map((skill, index) => (
              <div className="skill-item" key={index}>
                <i className={`${skill.icon} skill-icon`}></i>
                <h3>{skill.title}</h3>
                <p>{skill.description}</p>
              </div>
            ))}
          </div>
        </section>
      </main>

      {/* Footer Section */}
      <footer>
        <div className="footer">
          <div className="footer-section">
            <h3>Prem's Portfolio</h3>
            <p>Building innovative solutions for the web, one project at a time.</p>
          </div>
          <div className="footer-section">
            <ul>
              <li><Link to="/" onClick={closeSidebar}>Home</Link></li>
              <li><Link to="/about" onClick={closeSidebar}>About</Link></li>
              <li><Link to="/skills" onClick={closeSidebar}>Skills</Link></li>
              <li><Link to="/contact" onClick={closeSidebar}>Contact me</Link></li>
            </ul>
          </div>
          <div className="footer-third">
            <h4>Connect with me:</h4>
            <ul>
              <li><a href="https://github.com/itachiuchiha241" target="_blank" rel="noopener noreferrer"><i className="fab fa-github"></i> GitHub</a></li>
              <li><a href="https://linkedin.com" target="_blank" rel="noopener noreferrer"><i className="fab fa-linkedin"></i> LinkedIn</a></li>
              <li><a href="mailto:prempawar241@gmail.com"><i className="fas fa-envelope"></i> Email Me</a></li>
            </ul>
          </div>
        </div>
        <div className="footer-rights">
          <p className="mb-0">&copy; 2025 Prem's Portfolio. All rights reserved.</p>
        </div>
      </footer>
    </div>
  );
};

export default Skills;
